import { render, staticRenderFns } from "./CountryOverviewDetails.vue?vue&type=template&id=a80d4202&"
import script from "./CountryOverviewDetails.vue?vue&type=script&lang=js&"
export * from "./CountryOverviewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports